var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-partm5"},[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }